import React from 'react';
import './Footer.css';

/* Multi idioma */
import {FormattedMessage} from 'react-intl';


const Footer = () =>{
    // Fecha
    let fecha = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="site-footer">
                <div className="copyright">
                    <p>
                        <FormattedMessage
                            id='footer-info'
                            defaultMessage='Page created by Mathew Jolly'
                        />
                    </p>
                    <p>&copy; {fecha}. All Rights Reserved.</p>
                </div>
                <div className="portfolio-versions">
                    <p className="versions-label">Portfolio Versions:</p>
                    <div className="versions-links">
                        <a href="https://mathewjolly1.vercel.app" target="_blank" rel="noopener noreferrer">v1</a>
                        <a href="https://mathewjolly.vercel.app" target="_blank" rel="noopener noreferrer">v2</a>
                    </div>
                </div>
                <div className="redes-sociales">
                    <a href="https://www.linkedin.com/in/mathew-jolly-34b558288/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
                    <a href="https://github.com/mathewjolly11" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>
                    <a href="https://www.instagram.com/mathew._anachalil/?igsh=MTQ3NTJheGRxaTZ2eA%3D%3D" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                    <a href="https://api.whatsapp.com/send?phone=9633264055" target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp"></i></a>
                </div>
            </div>
        </footer>
    )
};

export default React.memo(Footer);